"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fetch_error_1 = require("./fetch_error");

exports.FetchError = fetch_error_1.default;

var types_1 = require("./types");

exports.HTTPMethod = types_1.HTTPMethod;
exports.HTTPContentType = types_1.HTTPContentType;
exports.HTTPAuthenticationScheme = types_1.HTTPAuthenticationScheme;

var defaults_1 = require("./defaults");

exports.configure = defaults_1.setDefaultOptions;

var prepare_fetch_arguments_1 = require("./prepare_fetch_arguments");

function originalFetch(url, options) {
  if (options === void 0) {
    options = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetch(url, options)];
    });
  });
}

exports.originalFetch = originalFetch;

function fetchResponse(url) {
  var options = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    options[_i - 1] = arguments[_i];
  }

  return __awaiter(this, void 0, void 0, function () {
    var _a, fetchUrl, fetchOptions, response, error_1, body;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _a = prepare_fetch_arguments_1.default(url, options), fetchUrl = _a[0], fetchOptions = _a[1];
          _b.label = 1;

        case 1:
          _b.trys.push([1, 3,, 4]);

          return [4, originalFetch(fetchUrl, fetchOptions)];

        case 2:
          response = _b.sent();

          if (response && response.status >= 100 && response.status <= 399) {
            return [2, response];
          }

          return [3, 4];

        case 3:
          error_1 = _b.sent();
          throw new fetch_error_1.default(0, error_1.message, null, error_1);

        case 4:
          return [4, response.text()];

        case 5:
          body = _b.sent();
          throw new fetch_error_1.default(response.status, body, response);
      }
    });
  });
}

exports.fetchResponse = fetchResponse;

function fetchJson(url) {
  var options = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    options[_i - 1] = arguments[_i];
  }

  return __awaiter(this, void 0, void 0, function () {
    var response, json;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, fetchResponse.apply(void 0, [url].concat(options))];

        case 1:
          response = _a.sent();
          return [4, response.json()];

        case 2:
          json = _a.sent();
          return [2, json];
      }
    });
  });
}

exports.fetchJson = fetchJson;

function fetchText(url) {
  var options = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    options[_i - 1] = arguments[_i];
  }

  return __awaiter(this, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, fetchResponse.apply(void 0, [url].concat(options))];

        case 1:
          response = _a.sent();
          return [2, response.text()];
      }
    });
  });
}

exports.fetchText = fetchText;

function fetchBlob(url) {
  var options = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    options[_i - 1] = arguments[_i];
  }

  return __awaiter(this, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, fetchResponse.apply(void 0, [url].concat(options))];

        case 1:
          response = _a.sent();
          return [2, response.blob()];
      }
    });
  });
}

exports.fetchBlob = fetchBlob;

function resource(baseUrlWithoutTrailingSlash) {
  var baseOptions = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    baseOptions[_i - 1] = arguments[_i];
  }

  function localFetch(relativePath) {
    var options = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      options[_i - 1] = arguments[_i];
    }

    var fullUrl = relativePath === '' ? baseUrlWithoutTrailingSlash : [baseUrlWithoutTrailingSlash, relativePath].join('/');
    return fetchJson.apply(void 0, [fullUrl].concat(baseOptions, options));
  }

  var fetchResource = {
    index: function (query) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [''].concat(options, [{
        method: types_1.HTTPMethod.get,
        query: query
      }]));
    },
    show: function (id) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [id.toString()].concat(options, [{
        method: types_1.HTTPMethod.get
      }]));
    },
    create: function (jsonData) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [''].concat(options, [{
        method: types_1.HTTPMethod.post,
        jsonData: jsonData
      }]));
    },
    update: function (jsonData) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [jsonData.id.toString()].concat(options, [{
        method: types_1.HTTPMethod.put,
        jsonData: jsonData
      }]));
    },
    destroy: function (id) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [id.toString()].concat(options, [{
        method: types_1.HTTPMethod.delete
      }]));
    },
    get: function (relativePath) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [relativePath].concat(options, [{
        method: types_1.HTTPMethod.get
      }]));
    },
    post: function (relativePath, jsonData) {
      var options = [];

      for (var _i = 2; _i < arguments.length; _i++) {
        options[_i - 2] = arguments[_i];
      }

      return localFetch.apply(void 0, [relativePath].concat(options, [{
        method: types_1.HTTPMethod.post,
        jsonData: jsonData
      }]));
    },
    put: function (relativePath, jsonData) {
      var options = [];

      for (var _i = 2; _i < arguments.length; _i++) {
        options[_i - 2] = arguments[_i];
      }

      return localFetch.apply(void 0, [relativePath].concat(options, [{
        method: types_1.HTTPMethod.put,
        jsonData: jsonData
      }]));
    },
    delete: function (relativePath) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [relativePath].concat(options, [{
        method: types_1.HTTPMethod.delete
      }]));
    },
    fetch: function (relativePath) {
      var options = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        options[_i - 1] = arguments[_i];
      }

      return localFetch.apply(void 0, [relativePath].concat(options));
    }
  };
  return fetchResource;
}

exports.resource = resource;